import { Alert, Button } from "@arco-design/web-react";

import "./financeOverview.css";

/**
 * 财务总览列表的读取结果提示：超过候选上限时提示加出团日期范围（后端整次拒绝、不截断，不显示残缺的合计），
 * 其他失败给出重试；两种都没有时不占位。
 */
export function FinanceOverviewListFeedback({
  listName,
  limitExceeded,
  failed,
  onRetry,
}: {
  listName: string;
  limitExceeded: boolean;
  failed: boolean;
  onRetry: () => void;
}) {
  if (limitExceeded) {
    return <Alert className="finance-overview-alert" type="warning" content="筛选出的团太多，请加出团日期范围。" />;
  }
  if (failed) {
    return (
      <Alert
        className="finance-overview-alert"
        type="error"
        content={`${listName}加载失败，请重试。`}
        action={<Button size="mini" onClick={onRetry}>重试</Button>}
      />
    );
  }
  return null;
}

/** 财务总览列表导出没成功的提示：超过候选上限提示加出团日期范围（后端不给截断的文件），其他失败提示重试。 */
export function FinanceOverviewExportFeedback({
  listName,
  error,
}: {
  listName: string;
  error: "limitExceeded" | "failed" | null;
}) {
  if (error === "limitExceeded") {
    return <Alert className="finance-overview-alert" type="warning" content="筛选出的团太多，请加出团日期范围后再导出。" />;
  }
  if (error === "failed") {
    return <Alert className="finance-overview-alert" type="error" content={`${listName}导出失败，请重试。`} />;
  }
  return null;
}

/** 财务总览列表的合计：算的是全部筛选结果，不只当前页；`label` 给读屏和测试定位用。 */
export function FinanceOverviewTotals({
  label,
  items,
}: {
  label: string;
  items: ReadonlyArray<{ name: string; value: string; note?: string }>;
}) {
  return (
    <dl className="finance-overview-totals" aria-label={label}>
      {items.map((item) => (
        <div key={item.name} className="finance-overview-total">
          <dt>{item.name}</dt>
          <dd>
            <span className="finance-overview-money">{item.value}</span>
            {item.note ? <span className="finance-overview-total-note">{item.note}</span> : null}
          </dd>
        </div>
      ))}
    </dl>
  );
}
